import React from "react";
import { Layout, EmptyStateMessage } from "@evertrue/et-components";
import { useChatCurrentUser } from "../contexts/chat-current-user-context";
import ChatLink from "./chat-room-link";
import useChatSearch from "../hooks/use-chat-search";
import Header from "./header";
import { makeRoomNameFromPoolId, getVMSPoolIdListFromRooms } from "../utils/utils";
import ChatActionBar from "./chat-action-bar";
import { useChatDependencyContext } from "../contexts/chat-dependency-context";

const ChatRoomList = () => {
  const {
    currentChatUser: { rooms = [] },
  } = useChatCurrentUser();

  const { oid } = useChatDependencyContext();
  const pool_ids = getVMSPoolIdListFromRooms(oid, rooms);

  const { users, onSearchChange, searchVal, pool_search_results, are_search_results } = useChatSearch({
    poolIds: pool_ids,
  });

  return (
    <Layout
      className="chat-room-list"
      headerBorder="none"
      header={
        <>
          <Header title="New Chat" showBack showClose />
          <ChatActionBar
            className="chat-room-list--action-bar"
            debounceTimeout={300}
            searchText={searchVal}
            setSearchText={onSearchChange}
            focusOnMount={true}
          />
        </>
      }
    >
      <div className="chat-room-list--body">
        {are_search_results ? (
          <>
            {Boolean(pool_search_results.length) &&
              pool_search_results.map(pool => {
                const room_name = makeRoomNameFromPoolId(oid, pool.id);
                const room = rooms.find(i => i.name === room_name) || {};
                return <ChatLink key={pool.id} name={pool.name} room={room} poolId={pool.id} />;
              })}

            {Boolean(users.length) &&
              users.map(user => {
                // et-user id is chatkit user id, need to send DM via chatkit ID

                return <ChatLink key={user.id} userId={user.id} />;
              })}
          </>
        ) : (
          <EmptyStateMessage
            className="chat-room-list--empty-state"
            size="small"
            icon="warning"
            text="No groups available for chat. Check setting or contact genius@evertrue.com for assistance."
          />
        )}
      </div>
    </Layout>
  );
};

ChatRoomList.propTypes = {};

export default ChatRoomList;
